import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20cinematic%20abstract%20composition%20with%20deep%20crimson%20and%20amber%20warm%20tones%2C%20dramatic%20atmospheric%20lighting%20with%20soft%20shadows%2C%20modern%20urban%20night%20vibe%2C%20editorial%20photography%20style%2C%20rich%20textured%20background%20with%20elegant%20gradation%2C%20no%20text%20no%20people%2C%20abstract%20artistic%20aesthetic&width=1600&height=900&seq=hero-bg-home&orientation=landscape"
          alt="51吃瓜黑料 - 全网独家爆料平台"
          title="51吃瓜黑料 吃瓜资源 网红反差视频"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              <p className="text-accent-300 font-label text-sm tracking-wider mb-3 uppercase">
                {heroData.tagline}
              </p>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
                {heroData.titleLine1}
                <br />
                {heroData.titleLine2}
                <br />
                <span className="text-accent-300">{heroData.titleLine3}</span>
              </h1>
              <p className="text-background-50/70 text-sm md:text-base max-w-lg mb-8 leading-relaxed">
                {heroData.subtitle}
              </p>
              <Link
                to={heroData.ctaLink}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
              >
                {heroData.ctaText}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}